/**
 * Points Path for Google Flights — award-travel helper
 *
 * A single web-accessible-resource group exposes images/*, a bundled font and every
 * *.js file to every origin, with no use_dynamic_url — so its icons and content scripts
 * sit at fixed, fetchable URLs. The optional-permission SVG icons are vendor-named and
 * load through an <img> with no CORS grant, so they survive a strict page CSP.
 *
 * Manifest verified against version 1.11.3.
 */

import { probeImage, probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'kblbdlhoeakihpcaimpdjnfkjffnhhej';

export const pointsPath: ExtensionDefinition = {
  id: ID,
  name: 'Points Path for Google Flights',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 100_000,
  notes:
    'images/*, a font and all *.js exposed to every origin with no dynamic URL. The ' +
    'vendor-named SVG icons load without a CORS grant; a fetch corroborates.',
  signals: [
    {
      id: 'war-chase-portal-icon',
      kind: 'web-accessible-resource',
      description:
        'Load images/optional_permissions/chase_portal_icon.svg via <img> — a vendor ' +
        'icon exposed to every origin, reachable without a CORS grant.',
      weight: 1,
      run: () => probeImage(ID, 'images/optional_permissions/chase_portal_icon.svg'),
    },
    {
      id: 'war-alarm-clock-svg',
      kind: 'web-accessible-resource',
      description:
        'Load images/alarmClock.svg via <img> — a second icon, corroborating without CORS.',
      weight: 0.5,
      run: () => probeImage(ID, 'images/alarmClock.svg'),
    },
    {
      id: 'war-flights-content-js',
      kind: 'web-accessible-resource',
      description:
        'Fetch flightsContent.js — the Google Flights content script, a distinct path ' +
        'independent of the icon signals.',
      weight: 0.5,
      run: () => probeFetch(ID, 'flightsContent.js'),
    },
  ],
};
